import "react-calendar/dist/Calendar.css";

import ReactCalendar from "react-calendar";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

import styles from "./calendar.module.scss";

interface Props {
  handleSetDateFilter: (dateFrom: Date, dateTo: Date) => void;
  handleCloseCalendar: () => void;
  value?: { dateFrom?: Date; dateTo?: Date };
}

const Calendar = ({
  value,
  handleCloseCalendar,
  handleSetDateFilter,
}: Props) => {
  const onChange = (e: Date[]) => {
    const dateFrom = e[0];
    const dateTo = e[1];
    if (dateFrom && dateTo) {
      handleSetDateFilter(dateFrom, dateTo);
      handleCloseCalendar();
    }
  };

  return (
    <div className={styles.container}>
      <ReactCalendar
        className={styles.calendar}
        tileClassName={styles.day}
        onChange={onChange}
        selectRange
        nextLabel={<FiArrowRight />}
        prevLabel={<FiArrowLeft />}
        view="month"
        value={[value?.dateFrom ?? null, value?.dateTo ?? null]}
        defaultActiveStartDate={new Date()}
      />
    </div>
  );
};

export default Calendar;
